import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const SCREENS = [
  { key: 'company', label: 'Company' },
  { key: 'you', label: 'You' },
];

/** Two-segment stepper for "Set up your company" plus a live required-field count. */
export function PartAStepper({ screen, missingCount, className }) {
  const current = screen === 'you' ? 2 : 1;
  return (
    <div className={cn('flex items-center justify-between gap-4', className)} data-testid="part-a-stepper">
      <div className="flex items-center gap-2">
        {SCREENS.map((s, idx) => {
          const n = idx + 1;
          const done = n < current;
          const active = n === current;
          return (
            <React.Fragment key={s.key}>
              {idx > 0 && <div className={cn('h-0.5 w-10', done || active ? 'bg-primary' : 'bg-muted')} />}
              <div className="flex items-center gap-2">
                <div
                  className={cn(
                    'flex h-7 w-7 items-center justify-center rounded-full border-2 text-xs font-medium',
                    done && 'border-primary bg-primary text-primary-foreground',
                    active && !done && 'border-primary bg-primary/10 text-primary',
                    !done && !active && 'border-muted-foreground/30 text-muted-foreground',
                  )}
                >
                  {done ? <Check className="h-3.5 w-3.5" /> : n}
                </div>
                <span className={cn('text-sm', active ? 'font-medium text-foreground' : 'text-muted-foreground')}>{s.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      {missingCount != null && (
        <span className="text-xs text-muted-foreground" data-testid="part-a-missing-count">
          {missingCount === 0 ? 'All required fields complete' : `${missingCount} field${missingCount === 1 ? '' : 's'} to go`}
        </span>
      )}
    </div>
  );
}

export { SCREENS as PART_A_SCREENS };
